import type { Route } from '@angular/router';
import { eventCategoryRoutes } from './category/event-category.routes';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';
import { CategoryFormServiceToken } from '../../common/category-details/abstract-category-form-service.token';
import { EventsCategoryFormService } from './service/events-category-form.service';

export const eventRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/event-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'category',
    children: eventCategoryRoutes,
    title: 'PAGES.EVENT.CATEGORY.BREADCRUMB.LIST',
    providers: [{ provide: CategoryFormServiceToken, useClass: EventsCategoryFormService }],
  },
  {
    path: 'new',
    loadComponent: () => import('./details/event-details.component'),
    title: 'PAGES.EVENT.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('./details/event-details.component'),
    title: 'PAGES.EVENT.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
];
